import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { FBaseService, collection } from '../services/firebase/f-base.service';
import { AuthService } from '../services/auth.service';
import { StorageItems } from '../constants/storage-items.constants';

export const subjectOwnerGuard = async (route: ActivatedRouteSnapshot) => {
  const fbService = inject(FBaseService);
  const authService = inject(AuthService);
  const router = inject(Router);

  try {
    const subjectId = route.params['subjectId'];
    if (!subjectId) {
      router.navigateByUrl('/select-subject');
      return false;
    }

    const userId = authService.user?.uid!;
    const isUserAdmin = localStorage.getItem(StorageItems.USER_ID_FOR_ADMIN);

    const currentUserData = await firstValueFrom(fbService.getById(collection.users, userId));
    const isAdministrator = currentUserData?.role === 'ADMINISTRATOR';

    if (isAdministrator) {
      const subject = await firstValueFrom(fbService.getById(collection.subjects, subjectId));
      if (!subject) {
        router.navigateByUrl('/select-subject');
        return false;
      }

      if (subject.metadata?.createdBy?.id) {
        console.log(subject.metadata?.createdBy?.id)
        localStorage.setItem(StorageItems.USER_ID_FOR_ADMIN, subject.metadata.createdBy.id);
        localStorage.setItem(StorageItems.LAST_SELECTED_SUBJECT, subjectId);
        return true;
      } else {
        router.navigateByUrl('/select-subject');
        return false;
      }
    }

    if (isUserAdmin) {
      localStorage.setItem(StorageItems.LAST_SELECTED_SUBJECT, subjectId);
      return true;
    }

    const subject = await firstValueFrom(fbService.getById(collection.subjects, subjectId));
    if (!subject) {
      router.navigateByUrl('/select-subject');
      return false;
    }

    if (subject.metadata?.createdBy?.id === userId) {
      localStorage.setItem(StorageItems.LAST_SELECTED_SUBJECT, subjectId);
      return true;
    }

    router.navigateByUrl('/select-subject');
    return false;

  } catch (error) {
    console.error('Subject owner guard error:', error);
    return false;
  }
};